/* Duchess Deluxe Hair — Global JS */
(function () {
  'use strict';

  /* ─── Scroll reveal ─── */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('show');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('show'); });
  }

  /* ─── Hero slideshow (2-slide auto-rotate, dot nav, hover-pause) ─── */
  function initHeroSlideshow() {
    var wraps = document.querySelectorAll('[data-hero-slideshow]');
    wraps.forEach(function (wrap) {
      var slides = wrap.querySelectorAll('.hero-slide');
      var dots = wrap.querySelectorAll('.hero-dot');
      if (slides.length < 2) return;

      var current = 0;
      var interval = parseInt(wrap.getAttribute('data-interval'), 10) || 5000;
      var timer = null;
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(idx) {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        current = idx;
      }
      function next() { show((current + 1) % slides.length); }
      function start() { if (!prefersReduced) timer = setInterval(next, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { stop(); show(i); start(); });
      });

      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);

      start();
    });
  }
  initHeroSlideshow();

  /* ─── Mobile menu ─── */
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var drawer = document.querySelector('[data-mobile-menu]');
  var backdrop = document.querySelector('[data-mobile-menu-backdrop]');
  var closeBtn = document.querySelector('[data-mobile-menu-close]');
  function openMenu() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (toggle) toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  /* ─── Testimonials carousel (mobile scroll) ─── */
  var testWrap = document.querySelector('[data-testimonials]');
  if (testWrap) {
    var grid = testWrap.querySelector('.testimonials-grid');
    var prev = testWrap.querySelector('.test-nav.prev');
    var next = testWrap.querySelector('.test-nav.next');
    function scrollBy(dir) {
      if (!grid) return;
      var card = grid.querySelector('.test-card');
      if (!card) return;
      grid.scrollBy({ left: dir * (card.offsetWidth + 22), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  }

  /* ─── Newsletter form messaging (uses Shopify native success/error) ─── */
  var newsletterForms = document.querySelectorAll('[data-newsletter-form]');
  newsletterForms.forEach(function (form) {
    var msg = form.parentElement && form.parentElement.querySelector('.newsletter-message');
    form.addEventListener('submit', function () {
      if (msg) msg.textContent = '';
    });
  });

  /* ─── Cart drawer link count auto-update (uses /cart.js) ─── */
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var count = data.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + count + ')';
        });
      })
      .catch(function () {});
  }
  refreshCartCount();

  /* ─── Add to cart via AJAX from product cards ─── */
  document.querySelectorAll('[data-product-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      e.preventDefault();
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          refreshCartCount();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Try Again';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = originalText; }, 2000);
        });
    });
  });

  /* ─── Product page — variant swap & image swap ─── */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantData = null;
    try {
      var script = productForm.querySelector('[data-product-json]');
      if (script) variantData = JSON.parse(script.textContent);
    } catch (err) { variantData = null; }

    var variantInput = productForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var thumbs = document.querySelectorAll('[data-media-thumb]');
    var mainImg = document.querySelector('[data-media-main] img');

    productForm.querySelectorAll('.variant-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var group = opt.closest('.variant-group');
        if (group) {
          group.querySelectorAll('.variant-option').forEach(function (o) { o.classList.remove('is-active'); });
        }
        opt.classList.add('is-active');

        if (!variantData) return;
        var groups = productForm.querySelectorAll('.variant-group');
        var selections = [];
        groups.forEach(function (g) {
          var a = g.querySelector('.variant-option.is-active');
          if (a) selections.push(a.getAttribute('data-value'));
        });

        var match = variantData.find(function (v) {
          return JSON.stringify(v.options) === JSON.stringify(selections);
        });

        if (match) {
          if (variantInput) variantInput.value = match.id;
          if (priceEl) priceEl.textContent = match.price;
          if (match.featured_image && mainImg) {
            mainImg.src = match.featured_image;
          }
        }
      });
    });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-src');
        if (mainImg && src) mainImg.src = src;
      });
    });

    var qtyInput = productForm.querySelector('[data-qty-input]');
    var qtyMinus = productForm.querySelector('[data-qty-minus]');
    var qtyPlus = productForm.querySelector('[data-qty-plus]');
    if (qtyMinus && qtyInput) qtyMinus.addEventListener('click', function () {
      var v = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      qtyInput.value = v;
    });
    if (qtyPlus && qtyInput) qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) + 1;
      qtyInput.value = v;
    });
  }
})();
